import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// import { useRouter } from 'state';
// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // console.log("scroll position: "+document.body.scrollHeight)
    window.scrollTo(0, 0);
    document.body.scrollTo(0, 0);
  }, [pathname]);

  return null;
}